import React from "react"
import {CatalogueContainer} from "./component"

export type DefaultContainerProps = {
    children: React.ReactNode
    hasMissions: boolean
    hasBanner: boolean
}

const StandardContainer = ({children, hasMissions, hasBanner}: DefaultContainerProps) => (
    <CatalogueContainer hasMissions={hasMissions} hasBanner={hasBanner}>
        {children}
    </CatalogueContainer>
)

export default StandardContainer
